import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';

export interface ILayoutRemoveBorderConfigInputProps {}

export function LayoutRemoveBorderConfigInput(
  props: ILayoutRemoveBorderConfigInputProps,
) {
  return (
    <FormItem
      name="layout.removeBorder"
      label={null}
      layout={{ removeLabelSpace: true }}
    >
      <CheckboxInput name="layout.removeBorder" defaultChecked={false}>
        Rimuovi bordo grafico
      </CheckboxInput>
    </FormItem>
  );
}
